import React from 'react';
import dataLayer from '@helpers/dataLayer';
import { RelatedDocumentItem } from '@layouts/Related/Related.types';
import { Thumbnail } from './Thumbnail';
import { getURLFileData } from '@helpers/URLHelpers';

interface RelatedDocItemProps {
  item: RelatedDocumentItem;
}

export const RelatedDocItem = ({ item }: RelatedDocItemProps) => {
  const onDownloadItem = () => {
    const { fileName } = getURLFileData(item.Url);
    dataLayer.push('file_download', {
      file_name: fileName,
      file_extension: item.MimeType,
      file_category: item.FileCategory,
      file_context: item.Tags.name,
      link_text: item.FileName,
      link_url: item.Url,
    });
  };

  return (
    <a
      download
      onClick={onDownloadItem}
      href={item.Url}
      className='c-document-list-item is-bound has-line-under'
      target='_blank'
      rel='noreferrer'
    >
      <div className='c-document-list-item-icon-container'>
        <i className='icon-download'></i>
      </div>
      <Thumbnail item={item} />
      <div className='c-document-list-item-tail'>
        <div className='c-document-list-item-tail-container'>
          <span className='c-document-list-item-main-text'>{item.FileName}</span>
          <span className='c-document-list-item-secondary-text'>
            {item.Description} {item.FileSize}
          </span>
        </div>
      </div>
    </a>
  );
};
